export default {
  ERROR: 'audioTrackerError',
  STOP_AUDIO_TRACKER: 'stopAudioTracker',
  START_AUDIO_TRACKER: 'startAudioTracker'
};
